import { MAX_CAROUSEL_TITLE_CHARS } from "../../../../../Utils/helpers/carouselHelper";

export const MAX_LINKS_SECTION_TITLE_CHARS = MAX_CAROUSEL_TITLE_CHARS;

export type LinkPresentationView = "grid" | "line";

export const LINK_PRESENTATION_OPTIONS: Array<{
  id: LinkPresentationView;
  label: string;
  icon: string;
}> = [
  { id: "grid", label: "Grid", icon: "grid_view" },
  { id: "line", label: "Rows", icon: "view_list" },
];

export const LINK_SECTION_PUBLISH_HELPER =
  "Once published, add your links to this section right on your page.";

export function isLinkPresentationView(
  value: string
): value is LinkPresentationView {
  return LINK_PRESENTATION_OPTIONS.some((option) => option.id === value);
}

/** Max characters for an individual link name (grid + line). */
export const MAX_LINK_NAME_CHARS = 60;

export function trimLinksSectionTitle(value: string) {
  return String(value || "").slice(0, MAX_LINKS_SECTION_TITLE_CHARS);
}

export function trimLinkName(value: string) {
  return String(value || "").slice(0, MAX_LINK_NAME_CHARS);
}

export function getLinksSectionTitleError(value: string): string | null {
  const trimmed = String(value || "").trim();
  if (!trimmed) {
    return "A title is required.";
  }
  if (trimmed.length > MAX_LINKS_SECTION_TITLE_CHARS) {
    return `Title must be ${MAX_LINKS_SECTION_TITLE_CHARS} characters or less.`;
  }
  return null;
}

export function getLinkNameError(value: string): string | null {
  const trimmed = String(value || "").trim();
  if (!trimmed) {
    return "Link title is required.";
  }
  if (trimmed.length > MAX_LINK_NAME_CHARS) {
    return `Link title must be ${MAX_LINK_NAME_CHARS} characters or less.`;
  }
  return null;
}
